import { styled } from '@mui/material';
import { getBasicActionStyling } from '../../Popover.utils';

export const ActionSetContainer = styled('div')(({ theme }) => ({
  ...getBasicActionStyling(theme),
  cursor: 'default'
}));
